import {
  provinceAndCityData,
  CodeToText
} from "element-china-area-data";

export function processProductList(list) {
  if (!list) {
    return [{
      id: '1',
      name: 'BN01',
      class: 'PET',
      color: 'T01',
      type: '高光板',
      spec: '',
      thick: 18,
      texture: '纹理一',
      count: '100',
      texture_method: '贴面工艺一',
      brand: '品牌一',
      remark: '一些备注',
      operationDesc: '一些入库说明'
    }]
  }
  return list.map((item) => {
    item.sortClass = item.class
    item.thick = String(item.thick);
    item.count = String(item.num);
    item.brand = item.brand_name;
    item.remark = item.remarks;
    item.material = item.type;
    item.brand_type = item.class;
    item.operationDesc = ''

    return item;
    // const {
    //   id, name, color, type, thick, texture, num, texture_method, brand_name, remarks, price, spec, pur_price
    // } = item;
    // return {
    //   id, name, color, type,
    //   thick: String(thick), texture, count: String(num),
    //   texture_method, brand: brand_name, remark: remarks,
    //   price, class: item.class, spec, pur_price
    // };
  });
}

export function getModifiedBillPayload(originalBillData, currentBillData, type) {
  // 对比当前数据和原始数据有和区别，有区别的商品写入到payload的data字段中
  let data = [];
  if (originalBillData.length == 0) {
    return currentBillData.map((item) => {
      return {
        commodity_type: 'plank',
        cid: item.id,
        num: `${type=='import' ? '+' : '-'}${Number(item.count)}`
      }
    })
  }
  originalBillData.forEach((element) => {
    if (element.id) {
      const target = currentBillData.find((item) => {
        return item.id == element.id;
      });
      let tmp = {};
      if (target) {
        // 当前单据中有之前相同的商品信息
        let numDelta = Number(target.count) - Number(element.count);
        if (numDelta < 0) {
          numDelta = `${type == 'import' ? '-' : '+'}${Math.abs(numDelta)}`;
        } else {
          numDelta = `${type == 'import' ? '+' : '-'}${numDelta}`;
        }
        tmp = {
          commodity_type: 'plank',
          cid: element.id,
          num: numDelta
        }
      } else {
        // 当前单据中没有之前相同的商品信息，说明做了删除操作，库存直接减去之前单据中该商品的全部记录库存
        tmp = {
          commodity_type: 'plank',
          cid: element.id,
          num: `${type == 'import' ? '-' : '+'}${element.count}`
        }
      }
      data.push(tmp);
    }
  });

  // 再遍历currentBillData中originalBillData里不存在的项目，说明做了新的添加，库存要做对应的添加
  const extractBills = currentBillData.filter((item) => {
    const currentId = item.id;
    return !originalBillData.find((orig) => {
      return orig.id == currentId
    });
  });
  data = data.concat(extractBills.map((item) => {
    return {
      commodity_type: 'plank',
      cid: item.id,
      num: `${type == 'import' ? '+' : '-'}${item.count}`
    }
  }))
  return data;
}

export function getImportExportRecord(data) {
  return data.map((item) => {
    const {
      code,
      remark,
      stock_id,
      user_name,
      create_time,
      manual_flag,
      order_no,
      order_id
    } = item;
    return {
      id: stock_id,
      num: code,
      client: user_name,
      remarks: remark,
      time: create_time,
      manual_flag,
      order_no,
      order_id
    }
  });
}

export function getInventoryRecord(data) {
  return data.map((item) => {
    const {
      order_code,
      remark,
      id,
      staff,
      create_time
    } = item;
    return {
      id,
      num: order_code,
      client: staff.staff_name,
      time: create_time,
      remarks: remark,
      time: create_time,
    }
  });
}

export function updateShopCarWithParams(payload, dataSource, mode, cloud_vip) {
  const {
    items
  } = payload;
  // 如果传入了对应字段，则更新购物车相应字段，没有传入则不更新
  const paramsNeedCheck = [
    'address', 'phone', 'customerName', 'remark'
  ];
  paramsNeedCheck.forEach((item) => {
    if (item in payload) {
      dataSource[item] = payload[item];
    }
  });

  // add模式对本次勾选的item做过滤，相同的商品合并，修改数量
  // update模式直接修改item为当前items值
  switch (mode) {
    case 'add':
      items.forEach((item) => {
        const index = dataSource.items.findIndex((product) => {
          return product.id == item.id;
        });
        if (index !== -1) {
          dataSource.items[index].count = Number(dataSource.items[index].count) + (item.count ? Number(item.count) : 1);
          // 是否是会员
          console.log(dataSource)
          if (cloud_vip) {
            dataSource.items[index].totalPrice = Number(Number(dataSource.items[index].count * dataSource.items[index].price || 0).toFixed(2));
          } else {
            dataSource.items[index].totalPrice = Number(Number(dataSource.items[index].count * dataSource.items[index].ret_price || 0).toFixed(2));
          }

        } else {
          item.count = 1;
          if (cloud_vip) {
            item.totalPrice = Number(Number(item.price || 0).toFixed(2));
          } else {
            item.totalPrice = Number(Number(item.ret_price || 0).toFixed(2));
          }
          dataSource.items.push(item);
        }
      })
      break;
    case 'update':
      dataSource.items = items.map((item) => {

        // 更新时，重新计算价格
        const result = {
          ...item
        };
        if (cloud_vip) {
          result.totalPrice = Number(Number(result.count * result.price || 0).toFixed(2));
        } else {
          result.totalPrice = Number(Number(result.count * result.ret_price || 0).toFixed(2));
        }

        return result;
      });
      break;
    default:
      break;
  }
  return dataSource;
}

export function mergeSameProduct(products, originProducts) {
  const result = [
    ...originProducts
  ]
  products.forEach((item) => {
    const index = result.findIndex((product) => {
      return product.id == item.id;
    });
    if (index !== -1) {
      result[index].count = Number(result[index].count) + (item.count !== undefined ? Number(item.count) : 1);
      // originProducts[index].totalPrice = Number(Number(dataSource.items[index].count * dataSource.items[index].price || 0).toFixed(2));
    } else {
      item.count = (item.count !== undefined ? Number(item.count) : 1);
      // item.totalPrice = Number(Number(item.price || 0).toFixed(2));
      result.push(item);
    }
  })
  return result;
}

export function updateColorShopCarWithParams(payload, dataSource, mode) {
  const {
    items
  } = payload;

  // 如果传入了对应字段，则更新购物车相应字段，没有传入则不更新
  const paramsNeedCheck = [
    'address', 'phone', 'customerName', 'remark'
  ];
  paramsNeedCheck.forEach((item) => {
    if (item in payload) {
      dataSource[item] = payload[item];
    }
  });

  // add模式对本次勾选的item做过滤，相同的商品合并，修改数量
  // update模式直接修改item为当前items值
  switch (mode) {
    case 'add':
      items.forEach((item) => {
        const index = dataSource.items.findIndex((product) => {
          return product.id == item.id;
        });
        // 购物车中有该商品
        if (index !== -1) {
          dataSource.items[index].count = Number(dataSource.items[index].count) + 1;
          dataSource.items[index].totalPrice = Number(Number(dataSource.items[index].count * dataSource.items[index].price || 0).toFixed(2));
        } else {
          // 购物车中无该商品
          item.count = 1;
          item.totalPrice = Number(Number(item.price || 0).toFixed(2));
          dataSource.items.push(item);
        }
      })
      break;
    case 'update':
      dataSource.items = items.map((item) => {
        // 更新时，重新计算价格
        const result = {
          ...item
        };
        result.totalPrice = Number(Number(result.count * result.price || 0).toFixed(2));
        return result;
      });
      break;
    default:
      break;
  }
  return dataSource;
}
export function shopCarInfoNormalize(data) {
  data.forEach((item) => {
    item.count = Number(item.num);
    item.brand = item.brand_name;
  })
  return data;
}

export function processingBasicMaterialFilter(data) {
  return data.bspec.map((item) => {
    return {
      text: item,
      value: item
    }
  })
}

export function processingClassFilter(data) {
  return data.plank_part_type_setting.map((item) => {
    return {
      text: item,
      value: item
    }
  })
}

export function getKeyValueWithFilter(filters) {
  const keyValue = {};
  // console.log('要处理过滤字段：',filters)
  for (let key in filters) {
    // console.log('处理过滤字段：',filters[key])
    if (filters[key] && filters[key].length > 0) {
      keyValue[key] = filters[key][0];
    }
  }
  return keyValue;
}

export function processingFilterOptions(options, keyTarget) {
  // console.log('过滤数据处理：',options, keyTarget)
  const result = {};
  for (let key in options) {
    if (keyTarget == key) {
      continue; // 刚改变过的属性，不改变其选项
    }
    result[key] = options[key].map((item) => {
      return {
        text: item,
        value: item
      }
    })
  }
  return result;
}
export function mergeFiterColorShopCar(data) {
  let result = []
  for (let i in data) {
    result = result.concat(data[i].items)
  }
  return result
}
export function handleOutStockList(infos, userInfo, supplier_id, address, staffId) {
  let Data = {}
  infos.forEach(item => {
    if (Data.hasOwnProperty(item.ex_supplier_id)) {
      Data[item.ex_supplier_id].push(item)
    } else {
      Data[item.ex_supplier_id] = []
      Data[item.ex_supplier_id].push(item)
    }
  })
  let formData = {}
  for (let i in Data) {
    let commodity_list = []
    let cost_money = 0
    Data[i].forEach(item => {
      let count = {
        id: item.id,
        count: item.needAdd
      }
      commodity_list.push(count)
      // 有些价格返回的None
      if (isNaN(Number(item.base_price))) {
        cost_money += 0
        console.log(cost_money)
      } else {

        cost_money += Number(item.base_price * item.needAdd)
        console.log(cost_money)
      }
    })
    formData[i] = {
      // 加参数绑定销售单绑定采购单
      customer_id: 0,
      manual_flag: 1,
      ex_supplier_id: Data[i][0].ex_supplier_id,
      name: Data[i][0].ex_supplier_name,
      supplier_id: supplier_id,
      uid: userInfo.id,
      remark: '',
      commodity_list: commodity_list,
      cost_money: cost_money,
      address: address.address,
      phone_number: userInfo.phone
    }
    if (staffId) {
      formData[i].staff_id = staffId
    }
  }
  return formData
}
export function handlePartOutImportStock(list, type, supplierInfo, userInfo) {
  console.log(supplierInfo)
  let req = {
    data: [],
    detail: [],
    remark: '',
    order_type: type == 'import' ? 1 : 2,
    supplier_id: supplierInfo ? supplierInfo.id : 0,
    // supplier_name: supplierInfo.name,
    uid: userInfo.id,
  }
  list.forEach(item => {
    let itemData = {
      cid: item.id,
      commodity_type: 'plank',
      num: `${type == 'import' ? '+' : '-'}${item.count}`
    }
    req.data.push(itemData)
    let detailData = {
      id: item.id,
      color: item.color_name || '',
      type: item.substrate || '',
      thick: item.thick || '',
      spec: item.spec || '',
      count: item.count || '',
      texture: item.texture || '',
      texture_method: item.texture_method || '',
      class: item.brand_type || '',
      brand: item.brand_name || '',
      remark: item.remark || '',
      operationDesc: '',
      adj_price: item.org_price == 'None' ? 0 : item.org_price || 0, //分仓价
      pur_price: item.base_price == 'None' ? 0 : item.base_price || 0, //采购价
      ret_price: item.price == 'None' ? 0 : item.price || 0, //零售价
      price: item.vip_price == 'None' ? 0 : item.vip_price || 0, //原价
      safe_stock: item.safe_num || 0,
      sortClass: item.brand_type || '', //商城分类
      width: item.width || 0,
      part_type: item.type, //商品分类，plank...
      name: item.name || '',
      material: item.material || '',
      content: item.item || '',
      brand_name: item.brand_name || '',
      brand_type: item.brand_type || ''
    }
    req.detail.push(detailData)

  })

  return req
}

export function handleSellerAndBuyerOrderDetail(list) {
  console.log('修改销售单数据：', list)
  let req = []
  list.forEach(item => {
    let detailData = dealDataFormat(item)
    // let a = dealDataFormat(item)
    // console.log(a)
    req.push(detailData)
  })
  return req
}
// 采购订单回显数据字段处理
function dealDataFormat(data) {
  let result = {}
  if (data.type == 'plank') {
    result = {
      id: data.id,
      color_name: data.color_name || '',
      detail_value: {
        spec: data.spec || '',
        substrate: data.substrate || '',
        texture_method: data.texture_method || '',
        thick: data.thick || '',
      },
      count: data.count || '',
      out_count: data.out_count || 0,
      brand_type: data.brand_type || '',
      brand_name: data.brand_name || '',
      remark: data.remark || '',
      operationDesc: '',

      adj_price: data.org_price == 'None' ? 0 : data.org_price || 0, //分仓价
      pur_price: data.base_price == 'None' ? 0 : data.base_price || 0, //采购价
      ret_price: data.price == 'None' ? 0 : data.price || 0, //零售价
      price: data.vip_price == 'None' ? 0 : data.vip_price || 0, //原价



      safe_stock: data.safe_num || 0,
      type: data.type, //商品分类，plank...
      name: data.name || '',
      commodity_id: data.commodity_id || 0, //销售单修改需要传回的快照id
      unit_price: data.unit_price || 0,
    }
  } else if (data.type == 'edge') {
    result = {
      id: data.id,
      detail_value: {
        thick: data.thick || '',
        content: data.content || '',
        material: data.material || '',
        spec: data.spec || '',
        width: data.width || '',
      },
      color_name: data.color_name || '',
      count: data.count || '',
      out_count: data.out_count || 0,
      remark: data.remark || '',
      operationDesc: '',
      adj_price: data.org_price == 'None' ? 0 : data.org_price || 0, //分仓价
      pur_price: data.base_price == 'None' ? 0 : data.base_price || 0, //采购价
      ret_price: data.price == 'None' ? 0 : data.price || 0, //零售价
      price: data.vip_price == 'None' ? 0 : data.vip_price || 0, //原价
      safe_stock: data.safe_num || 0,
      type: data.type, //商品分类，plank...
      name: data.name || '',
      commodity_id: data.commodity_id || 0, //销售单修改需要传回的快照id
      unit_price: data.unit_price || 0,
    }
  } else if (data.type == 'hardware') {
    result = {
      id: data.id,
      brand_type: data.brand_type || '',
      detail_value: {
        color: data.color || '',
        brand: data.brand || '',
        content: data.content || '',
        spec: data.spec || '',
        material: data.material || '',
      },
      count: data.count || '',
      out_count: data.out_count || 0,
      remark: data.remark || '',
      operationDesc: '',
      adj_price: data.org_price == 'None' ? 0 : data.org_price || 0, //分仓价
      pur_price: data.base_price == 'None' ? 0 : data.base_price || 0, //采购价
      ret_price: data.price == 'None' ? 0 : data.price || 0, //零售价
      price: data.vip_price == 'None' ? 0 : data.vip_price || 0, //原价

      safe_stock: data.safe_num || 0,
      type: data.type, //商品分类，plank...
      name: data.name || '',
      commodity_id: data.commodity_id || 0, //销售单修改需要传回的快照id
      unit_price: data.unit_price || 0,
    }
  } else if (data.type == 'door') {
    result = {
      id: data.id,
      detail_value: {
        thick: data.thick || '',
        color: data.color || '',
        content: data.content || "",
        material: data.material || '',
        spec: data.spec || '',
      },
      brand_type: data.brand_type || '',
      // brand:data.brand||'',
      count: data.count || '',
      out_count: data.out_count || 0,
      remark: data.remark || '',
      operationDesc: '',
      adj_price: data.org_price == 'None' ? 0 : data.org_price || 0, //分仓价
      pur_price: data.base_price == 'None' ? 0 : data.base_price || 0, //采购价
      ret_price: data.price == 'None' ? 0 : data.price || 0, //零售价
      price: data.vip_price == 'None' ? 0 : data.vip_price || 0, //原价
      safe_stock: data.safe_num || 0,
      type: data.type, //商品分类，plank...
      name: data.name || '',
      commodity_id: data.commodity_id || 0, //销售单修改需要传回的快照id
      unit_price: data.unit_price || 0,
    }
  } else if (data.type == 'other') {
    result = {
      id: data.id,
      detail_value: {
        brand: data.brand || '',
        color: data.color || '',
        content: data.content || '',
        material: data.material || '',
        spec: data.spec || '',
      },
      brand_type: data.brand_type || '',
      // thick:data.thick||'',
      count: data.count || '',
      out_count: data.out_count || 0,
      remark: data.remark || '',
      operationDesc: '',
      adj_price: data.org_price == 'None' ? 0 : data.org_price || 0, //分仓价
      pur_price: data.base_price == 'None' ? 0 : data.base_price || 0, //采购价
      ret_price: data.price == 'None' ? 0 : data.price || 0, //零售价
      price: data.vip_price == 'None' ? 0 : data.vip_price || 0, //原价
      safe_stock: data.safe_num || 0,
      type: data.type, //商品分类，plank...
      name: data.name || '',
      commodity_id: data.commodity_id || 0, //销售单修改需要传回的快照id
      unit_price: data.unit_price || 0,
    }
  } else if (data.type == 'album') {
    result = {
      id: data.id,
      class: data.brand_type || '',
      brand_type: data.brand_type || '',
      color_description: data.color_description || '',
      content: data.content,
      type: data.material || '',
      thick: data.thick || '',
      brand: data.brand || '',
      spec: data.spec || '',
      count: data.count || '',
      out_count: data.out_count || 0,
      remark: data.remark || '',
      operationDesc: '',
      adj_price: data.org_price == 'None' ? 0 : data.org_price || 0, //分仓价
      pur_price: data.base_price == 'None' ? 0 : data.base_price || 0, //采购价
      ret_price: data.price == 'None' ? 0 : data.price || 0, //零售价
      price: data.vip_price == 'None' ? 0 : data.vip_price || 0, //原价
      safe_stock: data.safe_num || 0,
      part_type: data.type, //商品分类，plank...
      name: data.name || '',
      commodity_id: data.commodity_id || 0, //销售单修改需要传回的快照id
      unit_price: data.unit_price || 0,
    }
  } else if (data.type == 'cabinet') {
    result = {
      id: data.id,
      detail_value: {
        substrate: data.substrate || '',
        thick: data.thick || '',
        spec: data.spec || '',
        texture_method: data.texture_method || ''
      },
      name: data.name || '',
      brand_type: data.brand_type || '',
      // class:data.class||'',
      color_name: data.color_name || '',
      count: data.count || '',
      out_count: data.out_count || 0,
      remark: data.remark || '',
      operationDesc: '',

      adj_price: data.org_price == 'None' ? 0 : data.org_price || 0, //分仓价
      pur_price: data.base_price == 'None' ? 0 : data.base_price || 0, //采购价
      ret_price: data.price == 'None' ? 0 : data.price || 0, //零售价
      price: data.vip_price == 'None' ? 0 : data.vip_price || 0, //原价
      safe_stock: data.safe_num || 0,
      type: data.type, //商品分类，plank...
      unit: data.unit || "",

      commodity_id: data.commodity_id || 0, //销售单修改需要传回的快照id
      unit_price: data.unit_price || 0,
    }
  }
  return result
}
export function handleForwardData(item) {
  let req = {}
  if (item.vip_price == 'None' || !item.vip_price) {
    item.vip_price = 0
  }
  if (item.unit_price == 'None' || !item.unit_price) {
    item.unit_price = 0
  }
  if (item.org_price == 'None' || !item.org_price) {
    item.org_price = 0
  }
  if (item.base_price == 'None' || !item.base_price) {
    item.base_price = 0
  }
  if (item.ret_price == 'None' || !item.ret_price) {
    item.ret_price = 0
  }
  switch (item.type) {
    case 'plank':
      req = {
        count: item.count,
        id: 0,
        price: Number(item.unit_price),
        vip_price: item.vip_price,
        org_price: item.org_price,
        base_price: item.base_price,
        part_type: "plank",
        brand_type: item.brand_type || '', //分类
        brand_name: item.brand_name || '', //品牌
        color_name: item.color_name || '', //板材颜色
        remark: item.remark, //板材备注
        steel_plate: item.steel_plate, //钢板纹理
        detail_value: {
          substrate: item.substrate || '', //基材
          thick: item.thick, //厚度
          spec: item.spec, //规格
          texture_method: item.texture_method, //贴面

        }
      }
      break
    case 'edge':
      req = {
        count: item.count,
        id: 0,
        price: Number(item.unit_price),
        vip_price: item.vip_price,
        org_price: item.org_price,
        base_price: item.base_price,
        part_type: "edge",
        color_name: item.color_name || '',
        name: item.name,
        remark: item.remark,
        detail_value: {
          material: item.material || '',
          thick: item.thick, //厚度
          spec: item.spec, //规格
          width: item.width
        }
      }
      break
    case 'hardware':
      req = {
        count: item.count,
        id: 0,
        price: Number(item.unit_price),
        vip_price: item.vip_price,
        org_price: item.org_price,
        base_price: item.base_price,
        part_type: "hardware",
        name: item.name,
        brand_type: item.brand_type,
        remark: item.remark, //板材备注
        detail_value: {
          color: item.color || '',
          material: item.material || '',
          thick: item.thick, //厚度
          spec: item.spec, //规格
          brand: item.brand
        }
      }
      break
    case 'door':
      req = {
        count: item.count,
        id: 0,
        price: Number(item.unit_price),
        vip_price: item.vip_price,
        org_price: item.org_price,
        base_price: item.base_price,
        part_type: "door",
        brand_type: item.brand_type,
        name: item.name,
        remark: item.remark, //板材备注
        detail_value: {
          color: item.color || '',
          material: item.material || '',
          thick: item.thick, //厚度
          spec: item.spec, //规格
        }
      }
      break
    case 'other':
      req = {
        count: item.count,
        id: 0,
        price: Number(item.unit_price),
        vip_price: item.vip_price,
        org_price: item.org_price,
        base_price: item.base_price,
        part_type: "other",
        brand_type: item.brand_type,
        remark: item.remark, //板材备注
        name: item.name,
        detail_value: {
          color: item.color || '',
          material: item.material || '',
          brand: item.brand,
          spec: item.spec, //规格
        }
      }
      break
    case 'album':
      req = {
        count: item.count,
        id: 0,
        price: Number(item.unit_price),
        vip_price: item.vip_price,
        org_price: item.org_price,
        base_price: item.base_price,
        part_type: "ohter",
        brand_type: item.brand_type,
        name: item.name,
        remark: item.remark, //板材备注
        detail_value: {
          color_description: item.color_description, //规格
        }
      }
      break
  }
  return req
}

export function handleOrderBlankRowData(item) { //空白行商品
  let req = {}
  if (item.vip_price == 'None' || !item.vip_price) {
    item.vip_price = 0
  }
  if (item.unit_price == 'None' || !item.unit_price) {
    item.unit_price = 0
  }
  if (item.org_price == 'None' || !item.org_price) {
    item.org_price = 0
  }
  if (item.base_price == 'None' || !item.base_price) {
    item.base_price = 0
  }
  if (item.ret_price == 'None' || !item.ret_price) {
    item.ret_price = 0
  }
  switch (item.type) {
    case 'plank':
      req = {
        uid: item.uid,
        supplier_id: item.supplier_id,
        count: item.count,
        id: 0,
        price: Number(item.price),
        vip_price: Number(item.price),
        org_price: Number(item.price),
        base_price: item.base_price,
        part_type: "plank",
        brand_type: item.class || '', //分类
        brand_name: item.brand || '', //品牌
        color_name: item.color || '', //板材颜色
        remark: item.remark, //板材备注
        steel_plate: item.texture, //钢板纹理
        detail_value: {
          substrate: item.type || '', //基材
          thick: item.thick, //厚度
          spec: item.spec, //规格
          texture_method: item.texture_method, //贴面

        }
      }
      break
    case 'edge':
      req = {
        uid: item.uid,
        supplier_id: item.supplier_id,
        count: item.count,
        id: 0,
        price: Number(item.price),
        vip_price: Number(item.price),
        org_price: Number(item.price),
        base_price: item.base_price,
        part_type: "edge",
        color_name: item.color || '',
        name: item.name,
        remark: item.remark,
        detail_value: {
          material: item.type || '',
          thick: item.thick, //厚度
          spec: item.spec, //规格
          width: item.width
        }
      }
      break
    case 'hardware':
      req = {
        uid: item.uid,
        supplier_id: item.supplier_id,
        count: item.count,
        id: 0,
        price: Number(item.price),
        vip_price: Number(item.price),
        org_price: Number(item.price),
        base_price: item.base_price,
        part_type: "hardware",
        name: item.name,
        brand_type: item.class,
        remark: item.remark, //板材备注
        detail_value: {
          color: item.color || '',
          material: item.type || '',
          thick: item.thick, //厚度
          spec: item.spec, //规格
          brand: item.brand
        }
      }
      break
    case 'door':
      req = {
        uid: item.uid,
        supplier_id: item.supplier_id,
        count: item.count,
        id: 0,
        price: Number(item.price),
        vip_price: Number(item.price),
        org_price: Number(item.price),
        base_price: item.base_price,
        part_type: "door",
        brand_type: item.brand_type,
        name: item.name,
        remark: item.remark, //板材备注
        detail_value: {
          color: item.color || '',
          material: item.type || '',
          thick: item.thick, //厚度
          spec: item.spec, //规格
        }
      }
      break
    case 'other':
      req = {
        uid: item.uid,
        supplier_id: item.supplier_id,
        count: item.count,
        id: 0,
        price: Number(item.price),
        vip_price: Number(item.price),
        org_price: Number(item.price),
        base_price: item.base_price,
        part_type: "other",
        brand_type: item.brand_type,
        remark: item.remark, //板材备注
        name: item.name,
        detail_value: {
          color: item.color || '',
          material: item.type || '',
          brand: item.brand,
          spec: item.spec, //规格
        }
      }
      break
    case 'album':
      req = {
        uid: item.uid,
        supplier_id: item.supplier_id,
        count: item.count,
        id: 0,
        price: Number(item.price),
        vip_price: Number(item.price),
        org_price: Number(item.price),
        base_price: item.base_price,
        part_type: "album",
        brand_type: item.class,
        name: item.name,
        remark: item.remark, //板材备注
        detail_value: {
          color_description: item.color_description, //规格
          content: item.content
        }
      }
      break
    case 'cabinet':
      req = {
        uid: item.uid,
        supplier_id: item.supplier_id,
        count: Number(item.count),
        id: 0,
        price: Number(item.price),
        vip_price: Number(item.price),
        org_price: Number(item.price),
        base_price: item.base_price,
        part_type: "cabinet",
        name: item.name, //名称
        color_name: item.color || '', //板材颜色
        remark: item.remark, //板材备注
        detail_value: {
          substrate: item.substrate || '', //基材
          thick: item.thick, //厚度
          spec: item.spec, //规格
          unit: item.unit,
          class: item.class || '', //分类
        }
      }
  }
  return req
}

export function getTypedProductDataArray(dataSource, type) {
  return dataSource.filter((product) => {
    if (product.part_type == 'album') {
      return product.class == type;
    }
    return product.part_type == type;
  })
}
export function getQuoteWithTable(data, orderId) {
  let req = []
  // delete data.curTab
  // delete data.total
  console.log('数据', data)
  for (let i in data) {
    if (data[i].type == 'door') {
      let reqItem = {
        id: index + 'door' + orderId,
        class: item.quotaItem || '',
        color: item.color || '',
        type: item.material || '',
        brand: item.brand || '',
        spec: item.matSize || '',
        count: item.amount || '',
        out_count: item.out_count || 0,
        remark: item.remark || '',
        operationDesc: '',
        adj_price: item.unitPrice, //分仓价
        pur_price: item.unitPrice, //采购价
        ret_price: item.unitPrice, //零售价
        price: item.unitPrice, //原价
        part_type: 'door',
        name: item.quotaItem || '',
        commodity_id: item.commodity_id || 0,
        unit_price: item.unitPrice || 0,
      }
      // req.push(reqItem)
    } else if (data[i].type == 'hardware') {
      let reqItem = {
        id: i,
        class: data[i].brand_type || '',
        color: data[i].detail_value.color || '',
        type: data[i].detail_value.material || '',
        brand: data[i].detail_value.brand || '',
        spec: data[i].detail_value.color.spec || '',
        count: data[i].count || '',
        out_count: data[i].out_count || 0,
        remark: data[i].remark || '',
        operationDesc: '',
        adj_price: Number(data[i].unit_price).toFixed(2), //分仓价
        pur_price: Number(data[i].unit_price).toFixed(2), //采购价
        ret_price: Number(data[i].unit_price).toFixed(2), //零售价
        price: Number(data[i].unit_price).toFixed(2), //原价
        part_type: 'hardware',
        name: data[i].name || '',
        commodity_id: data[i].commodity_id || 0,
        unit_price: Number(data[i].unit_price).toFixed(2),
      }
      req.push(reqItem)
    } else if (data[i].type == 'wardrobe') {
      // console.log('柜体',i,data[i])
      let reqItem = {
        id: i + orderId,
        class: data[i].class || '',
        name: data[i].name || '',
        color: data[i].color || '',
        spec: data[i].matSize || '',
        thick: data[i].thick || '',
        substrate: data[i].substrate || '',
        adj_price: Number(data[i].unit_price).toFixed(2), //分仓价
        pur_price: Number(data[i].unit_price).toFixed(2), //采购价
        ret_price: Number(data[i].unit_price).toFixed(2), //零售价
        price: Number(data[i].unit_price).toFixed(2), //原价
        count: 1,
        out_count: data[i].out_count || 0,
        remark: data[i].remark || '',
        operationDesc: '',
        part_type: 'cabinet',
        commodity_id: data[i].commodity_id || 0,
        unit_price: data[i].unitPrice || 0,
        unit: '元/个',
        wardrobe: true
      }
      // req.push(reqItem)
    } else if (data[i].type == 'cabinet') {
      console.log('柜门商品：', data[i])
      let classArr = data[i].name.split("_") //截取分类
      // let matCodeArr =  data[i][0].matCode.split('')
      // let thick = ''
      // let thickArr = []
      // let substrateArr = []
      // let a = ''
      // for(let i in matCodeArr){
      //   if(Number(matCodeArr[i]) || matCodeArr[i] == '.'){
      //     thickArr.push(matCodeArr[i])
      //   }else{
      //     a = i
      //   }
      //   if(i>=a && a){
      //     substrateArr.push(matCodeArr[i])
      //   }
      // }
      let reqItem = {
        id: i,
        class: classArr[0] || '',
        name: data[i].brand_type || '',
        color: data[i].color_name || '',
        spec: data[i].detail_value.spec || '',
        thick: data[i].detail_value.thick || '',
        substrate: data[i].detail_value.substrate || '',
        adj_price: Number(data[i].unit_price).toFixed(2), //分仓价
        pur_price: Number(data[i].unit_price).toFixed(2), //采购价
        ret_price: Number(data[i].unit_price).toFixed(2), //零售价
        price: Number(data[i].unit_price).toFixed(2), //原价
        count: data[i].count || '',
        out_count: data[i].out_count || 0,
        remark: data[i].remark || '',
        operationDesc: '',
        part_type: 'cabinet',
        commodity_id: data[i].commodity_id || 0,
        unit_price: Number(data[i].unit_price).toFixed(2),
        unit: data[i].unit || '',
        wardrobe: false
      }
      req.push(reqItem)
      console.log('整理好的数据', req)
    }
  }
  console.log('return整理好的数据', req)
  return req
}
export function handleOrderList(list) {
  let orderList = {}
  let newList = []
  list.forEach(item => {
    if (orderList.hasOwnProperty(item.supplier_id)) {
      orderList[item.supplier_id].push(item)
    } else {
      orderList[item.supplier_id] = []
      orderList[item.supplier_id].push(item)
    }
  })

  for (let i in orderList) {
    newList.push(orderList[i])
  }
  // console.log(newList)
  return newList
}
export function handleOrderListNew(list) {
  let orderList = {}
  let newList = []
  list.forEach(item => {
    if (orderList.hasOwnProperty(item.supplier_id)) {
      orderList[item.supplier_id].push(item)
    } else {
      orderList[item.supplier_id] = []
      orderList[item.supplier_id].push(item)
    }
  })
  console.log(orderList)
  for (let i in orderList) {

  }
  return newList
}
export function handleAttributesName(type) {
  let data = []
  const AttributesList = [{
    typeName: 'cabinet',
    list: [{
      title: '名称',
      option: 'name'
    },
    // {
    //   title: '宽度',
    //   option: 'width_scope'
    // }, {
    //   title: '厚度',
    //   option: 'height_scope'
    // },
    {
      title: '分类',
      value: '柜体'
    }, ]
  }, {
    typeName: 'furniture',
    list: [{
      title: '名称',
      option: 'name'
    },
    // {
    //   title: '宽度',
    //   option: 'width_scope'
    // }, {
    //   title: '厚度',
    //   option: 'height_scope'
    // },
    {
      title: '分类',
      value: '家具'
    }, ]
  }, {
    typeName: 'shutter',
    list: [{
      title: '名称',
      option: 'name'
    },
    // {
    //   title: '宽度',
    //   option: 'width_scope'
    // }, {
    //   title: '厚度',
    //   option: 'height_scope'
    // },
    {
      title: '分类',
      value: '门窗'
    }, ]
  }, {
    typeName: 'woodenDoor',
    list: [{
      title: '名称',
      option: 'name'
    },
    // {
    //   title: '宽度',
    //   option: 'width_scope'
    // }, {
    //   title: '厚度',
    //   option: 'height_scope'
    // },
    {
      title: '分类',
      value: '木门'
    }, ]
  }, {
    typeName: 'other',
    list: [{
      title: '颜色',
      option: 'color'
    }, {
      title: '规格',
      option: 'spec'
    }, {
      title: '材质',
      option: 'material'
    }, {
      title: '分类',
      option: 'brand_type'
    }, ]
  }]
  AttributesList.forEach(item => {
    if (item.typeName == type) {
      data = item.list
    }
  })
  return data
}

export function handleOrder(orderList) {
  let orders = []
  orderList.forEach(item => {
    let data = {
      id: item.id,
      count: item.num,
    }
    orders.push(data)
  })
  return orders
}

export function beforeHeadleOrder(orderList) {
  let cloud_sup = [];
  let other_sup = [];
  let orders = {
    self: {},
    cloud: {}
  }
  let dealOrder = []
  orderList.forEach(item => {
    // cloud_id不为空是加入了云仓的供应商,分别放入不同的数组
    if (item.order_type) {
      cloud_sup.push(item)
    } else {
      other_sup.push(item)
    }
  })
  cloud_sup.forEach(item => {
    // cloud订单里有该供应商的数组，直接push订单到数组里
    if (orders.cloud.hasOwnProperty(item.cloud_id)) {
      orders.cloud[item.cloud_id].push(item)
    } else {
      // cloud订单里没有该供应商的数组，增加新的数组
      orders.cloud[item.cloud_id] = []
      orders.cloud[item.cloud_id].push(item)
    }
  })
  other_sup.forEach(item => {
    // self订单里有该供应商的数组，直接push订单到数组里
    if (orders.self.hasOwnProperty(item.supplier_id)) {
      orders.self[item.supplier_id].push(item)
    } else {
      // self订单里没有该供应商的数组，增加新的数组
      orders.self[item.supplier_id] = []
      orders.self[item.supplier_id].push(item)
    }
  })
  for (let i in orders) {
    for (let j in orders[i]) {
      dealOrder.push(orders[i][j])
    }
  }
  return dealOrder
}

export function getProvinceData() {
  return provinceAndCityData.map((province) => {
    return {
      value: province.value,
      label: province.label,
      all: {
        value: province.value,
        label: province.label
      },
      children: province.children.map((city) => {
        return {
          value: city.value,
          label: city.label,
          all: {
            value: city.value,
            label: city.label
          }
        }
      })
    }
  })
}